// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Variables */
:root {
  --primary-gradient: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);
  --secondary-gradient: linear-gradient(135deg, #26c6da 0%, #00acc1 100%);
  --success-gradient: linear-gradient(135deg, #66bb6a 0%, #43a047 100%);
  --danger-gradient: linear-gradient(135deg, #ef5350 0%, #e53935 100%);
  --card-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --transition: all 0.3s ease;
}

.admin-panel {
  min-height: 100vh;
  background: #f8fafc;
  padding: 0;
}

.admin-header {
  background: var(--primary-gradient);
  padding: 24px 32px;
  box-shadow: var(--card-shadow);
  margin-bottom: 2px;
}

.admin-header h1 {
  color: white;
  font-size: 1.75rem;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.admin-panel .admin-header .logout-btn {
  padding: 10px 20px;
  background: var(--danger-color);
  color: white;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease-in-out;
}

.admin-panel .admin-header .logout-btn:hover {
  background: var(--primary-dark);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.admin-panel .admin-header .logout-btn:active {
  transform: translateY(0);
  box-shadow: none;
}

.admin-nav {
  background: white;
  padding: 0 32px;
  border-bottom: none;
  box-shadow: var(--card-shadow);
  display: flex;
  gap: 8px;
  position: sticky;
  top: 0;
  z-index: 100;
}

.tab-btn {
  padding: 16px 24px;
  border: none;
  background: none;
  color: #64748b;
  cursor: pointer;
  font-weight: 500;
  transition: var(--transition);
  border-radius: 0;
  position: relative;
}

.tab-btn::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  height: 3px;
  background: var(--primary-gradient);
  transition: var(--transition);
  transform: translateX(-50%);
}

.tab-btn:hover::after {
  width: 100%;
}

.tab-btn.active {
  background: transparent;
  color: #2196f3;
}

.tab-btn.active::after {
  width: 100%;
}

.admin-content {
  padding: 32px;
  max-width: 1400px;
  margin: 0 auto;
}

/* Modern Card Styling */
.add-form, .edit-form, .business-checks {
  background: white;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  padding: 24px;
  margin-bottom: 32px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

/* Enhanced Form Controls */
.add-form input,
.add-form select,
.add-form textarea,
.edit-form input,
.edit-form select,
.edit-form textarea {
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 20px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: var(--transition);
  background: #f8fafc;
}

.add-form input:focus,
.add-form select:focus,
.add-form textarea:focus,
.edit-form input:focus,
.edit-form select:focus,
.edit-form textarea:focus {
  outline: none;
  border-color: #2196f3;
  background: white;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
}

.add-form button {
  background: var(--success-color);
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.3s ease;
}

.add-form button:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

/* Modern Table Styling */
.table-container {
  background: white;
  border-radius: 12px;
  box-shadow: var(--card-shadow);
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-top: 0;
}

th {
  background: #f8fafc;
  font-weight: 600;
  color: #475569;
  padding: 16px;
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 0.5px;
}

td {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
  color: #334155;
}

tr:hover td {
  background: #f1f5f9;
}

/* Enhanced Buttons */
.edit-btn, .delete-btn, .add-credits-btn {
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  transition: var(--transition);
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.edit-btn {
  background: var(--secondary-gradient);
  color: white;
}

.delete-btn {
  background: var(--danger-gradient);
  color: white;
}

.add-credits-btn {
  background: var(--success-gradient);
  color: white;
}

/* Credits Management Enhancement */
.credits-management {
  background: #f8fafc;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e2e8f0;
}

.credits-info {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  margin: 16px 0;
}

.credits-stat {
  padding: 16px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.credits-label {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 4px;
}

.credits-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #334155;
}

/* Environment Badge Enhancement */
.environment-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.environment-badge.test {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.environment-badge.live {
  background: rgba(239, 83, 80, 0.1);
  color: #ef5350;
}

/* Add some spacing for the environment select */
select[name="environment"] {
  margin: 8px 0;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.notifications-section {
  padding: 20px;
}

.section-description {
  margin-bottom: 20px;
  color: #666;
}

.notification-test-form {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.notification-test-form .form-group {
  margin-bottom: 15px;
}

.notification-test-form label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.notification-test-form select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
}

.create-notification-btn {
  width: 100%;
  padding: 12px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  margin-top: 10px;
}

.create-notification-btn:hover {
  background-color: #388E3C;
}

.create-notification-btn:disabled {
  background-color: #9E9E9E;
  cursor: not-allowed;
}

.notification-result {
  margin-top: 15px;
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
}

.notification-result.success {
  background-color: rgba(76, 175, 80, 0.1);
  color: #388E3C;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.notification-result.error {
  background-color: rgba(244, 67, 54, 0.1);
  color: #D32F2F;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

.notification-info {
  margin-top: 30px;
}

.notification-types-list {
  list-style-type: none;
  padding: 0;
}

.notification-types-list li {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.notification-types-list li:last-child {
  border-bottom: none;
}

.credits-management {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  margin-top: 5px;
}

.credits-field {
  display: flex;
  align-items: center;
  gap: 10px;
}

.credits-field input {
  width: 120px;
}

.credits-info {
  display: flex;
  gap: 20px;
  font-size: 0.9em;
  color: #666;
}

.add-credits-btn {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  align-self: flex-start;
  margin-top: 5px;
}

.add-credits-btn:hover {
  background-color: #218838;
}

@media (max-width: 768px) {
  .admin-header {
    padding: 20px;
  }

  .admin-nav {
    padding: 0 16px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .admin-content {
    padding: 16px;
  }

  .credits-info {
    grid-template-columns: 1fr;
  }

  .table-container {
    margin: 0 -16px;
    border-radius: 0;
  }

  .add-form {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .add-form input,
  .add-form select,
  .add-form textarea {
    margin-bottom: 8px;
  }

  table, thead, tbody, th, td, tr {
    display: block;
  }

  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    margin-bottom: 16px;
    border: 1px solid var(--border-color);
    border-radius: var(--radius-sm);
  }

  td {
    display: flex;
    flex-direction: column;
    border: none;
    padding: 8px 12px;
    text-align: left;
    min-height: 60px;
    position: relative;
  }

  td:before {
    content: attr(data-label);
    font-weight: bold;
    margin-bottom: 4px;
    font-size: 0.85rem;
    color: var(--text-secondary);
    position: static;
  }

  td:last-child {
    flex-direction: column;
    gap: 8px;
  }

  td:last-child:before {
    margin-bottom: 8px;
  }

  td:last-child > div {
    display: flex;
    gap: 8px;
  }

  .edit-form {
    padding: 16px;
  }

  .edit-form form > div {
    margin-bottom: 12px;
  }

  .form-buttons {
    flex-direction: column;
    gap: 8px;
  }

  .form-buttons button {
    width: 100%;
  }

  .edit-btn,
  .delete-btn {
    flex: 1 1;
    text-align: center;
  }
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  font-size: 1.2rem;
  color: var(--text-secondary);
}

.edit-form {
  background: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.edit-form h3 {
  margin-top: 0;
  margin-bottom: 20px;
}

.edit-form form > div {
  margin-bottom: 15px;
}

.edit-form label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.edit-form input,
.edit-form select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.form-buttons {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.form-buttons button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.form-buttons button[type="submit"] {
  background: #4CAF50;
  color: white;
}

.form-buttons button[type="button"] {
  background: #f44336;
  color: white;
}

.reports-section {
  padding: 20px;
}

.business-checks {
  margin-bottom: 30px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.business-checks h3 {
  margin-bottom: 15px;
  color: #333;
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
}

.business-summary {
  margin: 10px 0;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.business-summary p {
  margin: 5px 0;
  font-weight: bold;
}

/* Add some spacing for the environment select */
select[name="environment"] {
  margin: 8px 0;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.notifications-section {
  padding: 20px;
}

.section-description {
  margin-bottom: 20px;
  color: #666;
}

.notification-test-form {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 30px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.notification-test-form .form-group {
  margin-bottom: 15px;
}

.notification-test-form label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
}

.notification-test-form select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
  font-size: 14px;
}

.create-notification-btn {
  width: 100%;
  padding: 12px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  margin-top: 10px;
}

.create-notification-btn:hover {
  background-color: #388E3C;
}

.create-notification-btn:disabled {
  background-color: #9E9E9E;
  cursor: not-allowed;
}

.notification-result {
  margin-top: 15px;
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
}

.notification-result.success {
  background-color: rgba(76, 175, 80, 0.1);
  color: #388E3C;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.notification-result.error {
  background-color: rgba(244, 67, 54, 0.1);
  color: #D32F2F;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

.notification-info {
  margin-top: 30px;
}

.notification-types-list {
  list-style-type: none;
  padding: 0;
}

.notification-types-list li {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
}

.notification-types-list li:last-child {
  border-bottom: none;
}

.credits-management {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  margin-top: 5px;
}

.credits-field {
  display: flex;
  align-items: center;
  gap: 10px;
}

.credits-field input {
  width: 120px;
}

.credits-info {
  display: flex;
  gap: 20px;
  font-size: 0.9em;
  color: #666;
}

.add-credits-btn {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  align-self: flex-start;
  margin-top: 5px;
}

.add-credits-btn:hover {
  background-color: #218838;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #334155;
}

.credits-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.credits-input-group input {
  width: 100%;
  padding: 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.credits-input-group input:focus {
  border-color: #2196f3;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
}

.quick-credit-buttons {
  display: flex;
  gap: 8px;
}

.quick-credit-buttons button {
  flex: 1 1;
  padding: 8px 16px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #475569;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.quick-credit-buttons button:hover {
  background: #e2e8f0;
  transform: translateY(-1px);
}

.quick-credit-buttons button:active {
  transform: translateY(0);
}

.credits-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.credits-input {
  width: 100%;
  padding: 8px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 6px;
  font-size: 1.5rem;
  font-weight: 600;
  color: #334155;
  background: white;
  transition: all 0.2s ease;
}

.credits-input:focus {
  outline: none;
  border-color: #2196f3;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
}

.credits-input::-webkit-inner-spin-button,
.credits-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.credits-input[type=number] {
  -moz-appearance: textfield;
}

.credits-actions {
  margin-top: 16px;
}

.credits-stat {
  background: #f8fafc;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.credits-label {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 8px;
}

.credits-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #334155;
}

.manual-checks-group {
  background: #f8fafc;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.manual-checks-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.manual-checks-info {
  flex: 1 1;
}

.manual-checks-info label {
  display: block;
  font-weight: 600;
  color: #334155;
  margin-bottom: 4px;
}

.manual-checks-info small {
  color: #64748b;
  font-size: 0.875rem;
}

/* Toggle Switch Styles */
.toggle-container {
  position: relative;
  min-width: 60px;
}

.toggle-checkbox {
  display: none;
}

.toggle-label {
  display: block;
  width: 60px;
  height: 34px;
  border-radius: 17px;
  background: #cbd5e1;
  cursor: pointer;
  position: relative;
  transition: background-color 0.3s ease;
}

.toggle-label:before {
  content: '';
  display: block;
  width: 26px;
  height: 26px;
  border-radius: 13px;
  background: white;
  position: absolute;
  top: 4px;
  left: 4px;
  transition: transform 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.toggle-checkbox:checked + .toggle-label {
  background: #2196f3;
}

.toggle-checkbox:checked + .toggle-label:before {
  transform: translateX(26px);
}

.toggle-checkbox:focus + .toggle-label {
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);
}

/* Schedules Section */
.schedules-section {
  padding: 20px;
}

.schedules-section .section-description {
  color: #7f8c8d;
  margin-bottom: 24px;
}

.schedules-overview {
  background: white;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 32px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.schedules-table {
  width: 100%;
  border-collapse: collapse;
}

.schedules-table th,
.schedules-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.schedules-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
}

.schedules-table tbody tr:hover {
  background-color: #f8f9fa;
}

.status-badge.enabled {
  background-color: rgba(46, 204, 113, 0.15);
  color: #27ae60;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.disabled {
  background-color: rgba(149, 165, 166, 0.15);
  color: #7f8c8d;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.completed {
  background-color: rgba(46, 204, 113, 0.15);
  color: #27ae60;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.running {
  background-color: rgba(52, 152, 219, 0.15);
  color: #2980b9;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.failed {
  background-color: rgba(231, 76, 60, 0.15);
  color: #c0392b;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.email-settings {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.email-badge {
  padding: 2px 8px;
  background-color: rgba(52, 152, 219, 0.15);
  color: #2980b9;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
}

.email-badge.disabled {
  background-color: rgba(149, 165, 166, 0.15);
  color: #7f8c8d;
}

.edit-schedule-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-schedule-modal .modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}

.edit-schedule-modal .modal-content {
  position: relative;
  background: white;
  border-radius: 12px;
  padding: 32px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  z-index: 1001;
}

.edit-schedule-modal h3 {
  margin-top: 0;
  margin-bottom: 24px;
  color: #2c3e50;
}

.edit-schedule-modal .form-group {
  margin-bottom: 20px;
}

.edit-schedule-modal .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
}

.edit-schedule-modal .form-group select,
.edit-schedule-modal .form-group .time-input,
.edit-schedule-modal .form-group .email-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
}

.edit-schedule-modal .form-group .email-input {
  font-family: monospace;
}

.edit-schedule-modal .form-group .form-help {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #7f8c8d;
  font-style: italic;
  line-height: 1.4;
}

.edit-schedule-modal .checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.edit-schedule-modal .checkbox-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: normal;
  color: #7f8c8d;
}

.edit-schedule-modal .checkbox-group input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.edit-schedule-modal .form-buttons {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.edit-schedule-modal .save-btn {
  flex: 1 1;
  padding: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.edit-schedule-modal .save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.edit-schedule-modal .cancel-btn {
  flex: 1 1;
  padding: 12px;
  background: #f8f9fa;
  color: #2c3e50;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.edit-schedule-modal .cancel-btn:hover {
  background: #e0e0e0;
}

/* Staff Exclusion List Styles */
.staff-exclusion-list {
  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 12px;
  background: #f8f9fa;
}

.staff-checkbox {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  margin-bottom: 8px;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
  font-weight: normal !important;
  color: #2c3e50 !important;
}

.staff-checkbox:hover {
  background: #f0f2f5;
  transform: translateX(4px);
}

.staff-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  flex-shrink: 0;
}

.staff-checkbox span {
  flex-grow: 1;
  font-size: 14px;
}

.loading-staff,
.no-staff {
  padding: 20px;
  text-align: center;
  color: #7f8c8d;
  font-style: italic;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
}

.schedule-runs-section {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-top: 24px;
}

.schedule-runs-section h3 {
  margin-top: 0;
  margin-bottom: 20px;
  color: #2c3e50;
}

.runs-table {
  width: 100%;
  border-collapse: collapse;
}

.runs-table th,
.runs-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.runs-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
}

.runs-table tbody tr:hover {
  background-color: #f8f9fa;
}

.changes-badge {
  padding: 4px 8px;
  background-color: rgba(241, 196, 15, 0.15);
  color: #f39c12;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.no-changes {
  color: #7f8c8d;
  font-size: 12px;
}

.email-sent {
  color: #27ae60;
  font-size: 16px;
  font-weight: bold;
}

.email-not-sent {
  color: #e74c3c;
  font-size: 16px;
  font-weight: bold;
}

/* Enhanced Run Display */
.error-summary {
  margin-top: 4px;
  font-size: 11px;
  color: #e74c3c;
  font-style: italic;
}

.progress-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.progress-text {
  font-weight: 600;
}

.failed-count {
  font-size: 11px;
  color: #e74c3c;
}

.credits-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.credits-detail {
  font-size: 11px;
  color: #7f8c8d;
}

.view-logs-btn {
  padding: 6px 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.view-logs-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

/* Logs Modal */
.logs-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.logs-modal-content {
  max-width: 1200px !important;
  width: 95% !important;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.logs-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #e0e0e0;
  margin-bottom: 20px;
}

.logs-modal .modal-header h3 {
  margin: 0;
  color: #2c3e50;
}

.logs-modal .close-btn {
  background: none;
  border: none;
  font-size: 32px;
  color: #7f8c8d;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.logs-modal .close-btn:hover {
  color: #e74c3c;
  transform: rotate(90deg);
}

.loading-logs {
  text-align: center;
  padding: 40px;
  color: #7f8c8d;
  font-size: 18px;
}

/* Run Summary */
.run-summary {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 24px;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.summary-item label {
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 600;
  text-transform: uppercase;
}

.summary-item span {
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.summary-item .success-count {
  color: #27ae60;
}

.summary-item .failed-count {
  color: #e74c3c;
}

.summary-item .changes-count {
  color: #f39c12;
}

.error-banner {
  background: rgba(231, 76, 60, 0.1);
  border-left: 4px solid #e74c3c;
  padding: 12px 16px;
  border-radius: 4px;
  color: #e74c3c;
  font-size: 14px;
}

/* Staff Logs Section */
.staff-logs-section {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.staff-logs-section h4 {
  margin: 0 0 16px 0;
  color: #2c3e50;
  font-size: 18px;
}

.logs-list {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-right: 8px;
}

/* Log Entry */
.log-entry {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.2s;
}

.log-entry:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.log-status-success {
  border-left: 4px solid #27ae60;
}

.log-status-failed {
  border-left: 4px solid #e74c3c;
}

.log-status-processing {
  border-left: 4px solid #3498db;
}

.log-status-pending {
  border-left: 4px solid #95a5a6;
}

.log-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.log-index {
  background: #667eea;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  min-width: 40px;
  text-align: center;
}

.log-staff-name {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.log-staff-name strong {
  color: #2c3e50;
  font-size: 14px;
}

.log-license {
  font-size: 12px;
  color: #7f8c8d;
  font-family: monospace;
}

.log-status-badge {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.log-status-badge.success {
  background: rgba(46, 204, 113, 0.15);
  color: #27ae60;
}

.log-status-badge.failed {
  background: rgba(231, 76, 60, 0.15);
  color: #e74c3c;
}

.log-status-badge.processing {
  background: rgba(52, 152, 219, 0.15);
  color: #3498db;
}

.log-status-badge.pending {
  background: rgba(149, 165, 166, 0.15);
  color: #7f8c8d;
}

/* Log Error */
.log-error {
  background: rgba(231, 76, 60, 0.1);
  border-radius: 6px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}

.error-code {
  background: #e74c3c;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  align-self: flex-start;
  font-family: monospace;
}

.error-message {
  color: #c0392b;
  font-size: 13px;
}

/* Log Success */
.log-success {
  background: rgba(46, 204, 113, 0.1);
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 8px;
}

.changes-indicator {
  color: #f39c12;
  font-weight: 600;
  font-size: 13px;
}

.no-changes-indicator {
  color: #7f8c8d;
  font-size: 13px;
}

.change-details {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.change-details ul {
  margin: 0;
  padding-left: 20px;
}

.change-details li {
  color: #2c3e50;
  font-size: 12px;
  margin-bottom: 4px;
}

/* Log Footer */
.log-footer {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  font-size: 11px;
  color: #7f8c8d;
  padding-top: 8px;
  border-top: 1px solid #e0e0e0;
}

.log-duration,
.log-credits,
.log-timestamp {
  display: flex;
  align-items: center;
  gap: 4px;
}

.no-logs {
  text-align: center;
  padding: 40px;
  color: #7f8c8d;
  font-style: italic;
  background: #f8f9fa;
  border-radius: 8px;
}

/* Modal Footer */
.modal-footer {
  padding-top: 20px;
  border-top: 2px solid #e0e0e0;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.close-footer-btn {
  padding: 12px 24px;
  background: #f8f9fa;
  color: #2c3e50;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.close-footer-btn:hover {
  background: #e0e0e0;
}

/* Active Runs Section with Live Progress */
.active-runs-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
  animation: slideDown 0.3s ease-out;
  scroll-margin-top: 20px;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Initializing Run Card */
.initializing-run-card {
  background: white;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-bottom: 16px;
  animation: fadeIn 0.4s ease-out;
  border-left: 4px solid #667eea;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.initializing-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #e0e0e0;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.initializing-text {
  flex: 1 1;
}

.initializing-text strong {
  font-size: 18px;
  color: #2c3e50;
  display: block;
  margin-bottom: 8px;
}

.initializing-text p {
  font-size: 14px;
  color: #7f8c8d;
  margin: 0;
}

.active-runs-section h3 {
  color: white;
  margin: 0 0 20px 0;
  font-size: 24px;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.active-runs-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.active-run-card {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.4s ease-out;
  border-left: 4px solid #667eea;
}

.active-run-card.completed {
  background: linear-gradient(to right, #f0f9ff 0%, #ffffff 100%);
  border-left-color: #10b981;
  opacity: 0.95;
}

.active-run-card.completed .active-run-header {
  opacity: 0.9;
}

.active-run-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 2px solid #f0f0f0;
}

.active-run-title {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.active-run-title strong {
  font-size: 18px;
  color: #2c3e50;
}

.active-run-time {
  color: #7f8c8d;
  font-size: 13px;
}

/* Progress Bar Container */
.progress-bar-container {
  margin-bottom: 20px;
}

.progress-bar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.progress-label {
  font-weight: 600;
  color: #2c3e50;
  font-size: 15px;
}

.progress-percent {
  font-weight: 700;
  color: #667eea;
  font-size: 16px;
}

.progress-bar-wrapper {
  width: 100%;
  height: 24px;
  background: #e0e0e0;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  position: relative;
  transition: width 0.5s ease;
  overflow: hidden;
}

.progress-bar-shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Active Run Stats */
.active-run-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
}

.stat-label {
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 600;
  text-transform: uppercase;
}

.stat-value {
  font-size: 20px;
  font-weight: 700;
  color: #2c3e50;
}

.success-stat .stat-value {
  color: #27ae60;
}

.failed-stat .stat-value {
  color: #e74c3c;
}

/* Recent Logs in Active Run */
.active-run-recent-logs {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;
}

.recent-logs-label {
  font-size: 12px;
  color: #7f8c8d;
  font-weight: 600;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.recent-log-entry {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  font-size: 13px;
}

.log-staff {
  color: #2c3e50;
  font-weight: 500;
}

.log-status {
  font-size: 16px;
}

.active-run-error {
  background: rgba(231, 76, 60, 0.1);
  border-left: 4px solid #e74c3c;
  padding: 12px;
  border-radius: 6px;
  color: #e74c3c;
  font-size: 14px;
  font-weight: 600;
}

/* Live Progress in Table */
.running-row {
  background: rgba(102, 126, 234, 0.05) !important;
  animation: pulse-row 2s ease-in-out infinite;
}

@keyframes pulse-row {
  0%, 100% {
    background: rgba(102, 126, 234, 0.05);
  }
  50% {
    background: rgba(102, 126, 234, 0.1);
  }
}

.status-badge.pulsing {
  animation: pulse-badge 1.5s ease-in-out infinite;
}

@keyframes pulse-badge {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.05);
  }
}

.status-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.live-progress-container {
  width: 100%;
}

.progress-bar-header-small {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #2c3e50;
}

.progress-percent-small {
  color: #667eea;
  font-weight: 700;
}

.progress-bar-wrapper-small {
  width: 100%;
  height: 16px;
  background: #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.progress-bar-fill-small {
  height: 100%;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  position: relative;
  transition: width 0.5s ease;
  overflow: hidden;
}

.progress-bar-fill-small .progress-bar-shimmer {
  animation: shimmer 1.5s infinite;
}

/* Email Status Badges */
.email-status-cell {
  display: flex;
  align-items: center;
}

.email-sent-badge {
  padding: 6px 12px;
  background: rgba(46, 204, 113, 0.15);
  color: #27ae60;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.email-not-sent-badge {
  padding: 6px 12px;
  background: rgba(231, 76, 60, 0.15);
  color: #e74c3c;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.email-pending-badge {
  padding: 6px 12px;
  background: rgba(52, 152, 219, 0.15);
  color: #3498db;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  animation: pulse-badge 2s ease-in-out infinite;
}

.recipient-emails {
  font-size: 12px;
}

.recipient-emails .email-list {
  padding: 4px 8px;
  background-color: rgba(52, 152, 219, 0.15);
  color: #2980b9;
  border-radius: 4px;
  font-weight: 600;
  cursor: help;
}

.recipient-emails .default-email {
  color: #7f8c8d;
  font-style: italic;
  cursor: help;
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.run-now-btn {
  padding: 6px 12px;
  background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.run-now-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(46, 204, 113, 0.3);
}

.run-now-btn:active:not(:disabled) {
  transform: translateY(0);
}

.run-now-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.run-now-btn.loading {
  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);
  animation: pulse-button 1.5s ease-in-out infinite;
}

@keyframes pulse-button {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/AdminPanel.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,qEAAqE;EACrE,uEAAuE;EACvE,qEAAqE;EACrE,oEAAoE;EACpE,oFAAoF;EACpF,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,QAAQ;EACR,WAAW;EACX,mCAAmC;EACnC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;;;;;;EAME,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;;;;;EAME,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,qCAAqC;IACrC,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAO;IACP,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,kCAAkC;EAClC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,+DAA+D;EAC/D,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,8BAA8B;AAChC;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;AACF;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,4DAA4D;EAC5D,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["/* Modern Variables */\n:root {\n  --primary-gradient: linear-gradient(135deg, #2196f3 0%, #1976d2 100%);\n  --secondary-gradient: linear-gradient(135deg, #26c6da 0%, #00acc1 100%);\n  --success-gradient: linear-gradient(135deg, #66bb6a 0%, #43a047 100%);\n  --danger-gradient: linear-gradient(135deg, #ef5350 0%, #e53935 100%);\n  --card-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --transition: all 0.3s ease;\n}\n\n.admin-panel {\n  min-height: 100vh;\n  background: #f8fafc;\n  padding: 0;\n}\n\n.admin-header {\n  background: var(--primary-gradient);\n  padding: 24px 32px;\n  box-shadow: var(--card-shadow);\n  margin-bottom: 2px;\n}\n\n.admin-header h1 {\n  color: white;\n  font-size: 1.75rem;\n  font-weight: 600;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.admin-panel .admin-header .logout-btn {\n  padding: 10px 20px;\n  background: var(--danger-color);\n  color: white;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.2s ease-in-out;\n}\n\n.admin-panel .admin-header .logout-btn:hover {\n  background: var(--primary-dark);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.admin-panel .admin-header .logout-btn:active {\n  transform: translateY(0);\n  box-shadow: none;\n}\n\n.admin-nav {\n  background: white;\n  padding: 0 32px;\n  border-bottom: none;\n  box-shadow: var(--card-shadow);\n  display: flex;\n  gap: 8px;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.tab-btn {\n  padding: 16px 24px;\n  border: none;\n  background: none;\n  color: #64748b;\n  cursor: pointer;\n  font-weight: 500;\n  transition: var(--transition);\n  border-radius: 0;\n  position: relative;\n}\n\n.tab-btn::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  width: 0;\n  height: 3px;\n  background: var(--primary-gradient);\n  transition: var(--transition);\n  transform: translateX(-50%);\n}\n\n.tab-btn:hover::after {\n  width: 100%;\n}\n\n.tab-btn.active {\n  background: transparent;\n  color: #2196f3;\n}\n\n.tab-btn.active::after {\n  width: 100%;\n}\n\n.admin-content {\n  padding: 32px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Modern Card Styling */\n.add-form, .edit-form, .business-checks {\n  background: white;\n  border-radius: 12px;\n  box-shadow: var(--card-shadow);\n  padding: 24px;\n  margin-bottom: 32px;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n/* Enhanced Form Controls */\n.add-form input,\n.add-form select,\n.add-form textarea,\n.edit-form input,\n.edit-form select,\n.edit-form textarea {\n  width: 100%;\n  padding: 12px 16px;\n  margin-bottom: 20px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  transition: var(--transition);\n  background: #f8fafc;\n}\n\n.add-form input:focus,\n.add-form select:focus,\n.add-form textarea:focus,\n.edit-form input:focus,\n.edit-form select:focus,\n.edit-form textarea:focus {\n  outline: none;\n  border-color: #2196f3;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);\n}\n\n.add-form button {\n  background: var(--success-color);\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.add-form button:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Modern Table Styling */\n.table-container {\n  background: white;\n  border-radius: 12px;\n  box-shadow: var(--card-shadow);\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\ntable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin-top: 0;\n}\n\nth {\n  background: #f8fafc;\n  font-weight: 600;\n  color: #475569;\n  padding: 16px;\n  text-transform: uppercase;\n  font-size: 0.85rem;\n  letter-spacing: 0.5px;\n}\n\ntd {\n  padding: 16px;\n  border-bottom: 1px solid #e2e8f0;\n  color: #334155;\n}\n\ntr:hover td {\n  background: #f1f5f9;\n}\n\n/* Enhanced Buttons */\n.edit-btn, .delete-btn, .add-credits-btn {\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-weight: 500;\n  transition: var(--transition);\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.edit-btn {\n  background: var(--secondary-gradient);\n  color: white;\n}\n\n.delete-btn {\n  background: var(--danger-gradient);\n  color: white;\n}\n\n.add-credits-btn {\n  background: var(--success-gradient);\n  color: white;\n}\n\n/* Credits Management Enhancement */\n.credits-management {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 20px;\n  border: 1px solid #e2e8f0;\n}\n\n.credits-info {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 16px;\n  margin: 16px 0;\n}\n\n.credits-stat {\n  padding: 16px;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.credits-label {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin-bottom: 4px;\n}\n\n.credits-value {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n/* Environment Badge Enhancement */\n.environment-badge {\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.environment-badge.test {\n  background: rgba(33, 150, 243, 0.1);\n  color: #2196f3;\n}\n\n.environment-badge.live {\n  background: rgba(239, 83, 80, 0.1);\n  color: #ef5350;\n}\n\n/* Add some spacing for the environment select */\nselect[name=\"environment\"] {\n  margin: 8px 0;\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n}\n\n.notifications-section {\n  padding: 20px;\n}\n\n.section-description {\n  margin-bottom: 20px;\n  color: #666;\n}\n\n.notification-test-form {\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.notification-test-form .form-group {\n  margin-bottom: 15px;\n}\n\n.notification-test-form label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.notification-test-form select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 14px;\n}\n\n.create-notification-btn {\n  width: 100%;\n  padding: 12px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  margin-top: 10px;\n}\n\n.create-notification-btn:hover {\n  background-color: #388E3C;\n}\n\n.create-notification-btn:disabled {\n  background-color: #9E9E9E;\n  cursor: not-allowed;\n}\n\n.notification-result {\n  margin-top: 15px;\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.notification-result.success {\n  background-color: rgba(76, 175, 80, 0.1);\n  color: #388E3C;\n  border: 1px solid rgba(76, 175, 80, 0.3);\n}\n\n.notification-result.error {\n  background-color: rgba(244, 67, 54, 0.1);\n  color: #D32F2F;\n  border: 1px solid rgba(244, 67, 54, 0.3);\n}\n\n.notification-info {\n  margin-top: 30px;\n}\n\n.notification-types-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.notification-types-list li {\n  padding: 10px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.notification-types-list li:last-child {\n  border-bottom: none;\n}\n\n.credits-management {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  margin-top: 5px;\n}\n\n.credits-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.credits-field input {\n  width: 120px;\n}\n\n.credits-info {\n  display: flex;\n  gap: 20px;\n  font-size: 0.9em;\n  color: #666;\n}\n\n.add-credits-btn {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  align-self: flex-start;\n  margin-top: 5px;\n}\n\n.add-credits-btn:hover {\n  background-color: #218838;\n}\n\n@media (max-width: 768px) {\n  .admin-header {\n    padding: 20px;\n  }\n\n  .admin-nav {\n    padding: 0 16px;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .admin-content {\n    padding: 16px;\n  }\n\n  .credits-info {\n    grid-template-columns: 1fr;\n  }\n\n  .table-container {\n    margin: 0 -16px;\n    border-radius: 0;\n  }\n\n  .add-form {\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .add-form input,\n  .add-form select,\n  .add-form textarea {\n    margin-bottom: 8px;\n  }\n\n  table, thead, tbody, th, td, tr {\n    display: block;\n  }\n\n  thead tr {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n\n  tr {\n    margin-bottom: 16px;\n    border: 1px solid var(--border-color);\n    border-radius: var(--radius-sm);\n  }\n\n  td {\n    display: flex;\n    flex-direction: column;\n    border: none;\n    padding: 8px 12px;\n    text-align: left;\n    min-height: 60px;\n    position: relative;\n  }\n\n  td:before {\n    content: attr(data-label);\n    font-weight: bold;\n    margin-bottom: 4px;\n    font-size: 0.85rem;\n    color: var(--text-secondary);\n    position: static;\n  }\n\n  td:last-child {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  td:last-child:before {\n    margin-bottom: 8px;\n  }\n\n  td:last-child > div {\n    display: flex;\n    gap: 8px;\n  }\n\n  .edit-form {\n    padding: 16px;\n  }\n\n  .edit-form form > div {\n    margin-bottom: 12px;\n  }\n\n  .form-buttons {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .form-buttons button {\n    width: 100%;\n  }\n\n  .edit-btn,\n  .delete-btn {\n    flex: 1;\n    text-align: center;\n  }\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  font-size: 1.2rem;\n  color: var(--text-secondary);\n}\n\n.edit-form {\n  background: #f5f5f5;\n  padding: 20px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n}\n\n.edit-form h3 {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.edit-form form > div {\n  margin-bottom: 15px;\n}\n\n.edit-form label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.edit-form input,\n.edit-form select {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n}\n\n.form-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.form-buttons button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.form-buttons button[type=\"submit\"] {\n  background: #4CAF50;\n  color: white;\n}\n\n.form-buttons button[type=\"button\"] {\n  background: #f44336;\n  color: white;\n}\n\n.reports-section {\n  padding: 20px;\n}\n\n.business-checks {\n  margin-bottom: 30px;\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.business-checks h3 {\n  margin-bottom: 15px;\n  color: #333;\n  border-bottom: 2px solid #eee;\n  padding-bottom: 10px;\n}\n\n.business-summary {\n  margin: 10px 0;\n  padding: 10px;\n  background-color: #f5f5f5;\n  border-radius: 4px;\n}\n\n.business-summary p {\n  margin: 5px 0;\n  font-weight: bold;\n}\n\n/* Add some spacing for the environment select */\nselect[name=\"environment\"] {\n  margin: 8px 0;\n  padding: 8px;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n}\n\n.notifications-section {\n  padding: 20px;\n}\n\n.section-description {\n  margin-bottom: 20px;\n  color: #666;\n}\n\n.notification-test-form {\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 30px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.notification-test-form .form-group {\n  margin-bottom: 15px;\n}\n\n.notification-test-form label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.notification-test-form select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background-color: white;\n  font-size: 14px;\n}\n\n.create-notification-btn {\n  width: 100%;\n  padding: 12px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  margin-top: 10px;\n}\n\n.create-notification-btn:hover {\n  background-color: #388E3C;\n}\n\n.create-notification-btn:disabled {\n  background-color: #9E9E9E;\n  cursor: not-allowed;\n}\n\n.notification-result {\n  margin-top: 15px;\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.notification-result.success {\n  background-color: rgba(76, 175, 80, 0.1);\n  color: #388E3C;\n  border: 1px solid rgba(76, 175, 80, 0.3);\n}\n\n.notification-result.error {\n  background-color: rgba(244, 67, 54, 0.1);\n  color: #D32F2F;\n  border: 1px solid rgba(244, 67, 54, 0.3);\n}\n\n.notification-info {\n  margin-top: 30px;\n}\n\n.notification-types-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.notification-types-list li {\n  padding: 10px 0;\n  border-bottom: 1px solid #eee;\n}\n\n.notification-types-list li:last-child {\n  border-bottom: none;\n}\n\n.credits-management {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px;\n  background: #f8f9fa;\n  border-radius: 6px;\n  margin-top: 5px;\n}\n\n.credits-field {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.credits-field input {\n  width: 120px;\n}\n\n.credits-info {\n  display: flex;\n  gap: 20px;\n  font-size: 0.9em;\n  color: #666;\n}\n\n.add-credits-btn {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  align-self: flex-start;\n  margin-top: 5px;\n}\n\n.add-credits-btn:hover {\n  background-color: #218838;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.credits-input-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.credits-input-group input {\n  width: 100%;\n  padding: 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.credits-input-group input:focus {\n  border-color: #2196f3;\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);\n}\n\n.quick-credit-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n.quick-credit-buttons button {\n  flex: 1;\n  padding: 8px 16px;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  color: #475569;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.quick-credit-buttons button:hover {\n  background: #e2e8f0;\n  transform: translateY(-1px);\n}\n\n.quick-credit-buttons button:active {\n  transform: translateY(0);\n}\n\n.credits-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.credits-input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 2px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #334155;\n  background: white;\n  transition: all 0.2s ease;\n}\n\n.credits-input:focus {\n  outline: none;\n  border-color: #2196f3;\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);\n}\n\n.credits-input::-webkit-inner-spin-button,\n.credits-input::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.credits-input[type=number] {\n  -moz-appearance: textfield;\n}\n\n.credits-actions {\n  margin-top: 16px;\n}\n\n.credits-stat {\n  background: #f8fafc;\n  padding: 16px;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.credits-label {\n  font-size: 0.875rem;\n  color: #64748b;\n  margin-bottom: 8px;\n}\n\n.credits-value {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n.manual-checks-group {\n  background: #f8fafc;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n}\n\n.manual-checks-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n}\n\n.manual-checks-info {\n  flex: 1;\n}\n\n.manual-checks-info label {\n  display: block;\n  font-weight: 600;\n  color: #334155;\n  margin-bottom: 4px;\n}\n\n.manual-checks-info small {\n  color: #64748b;\n  font-size: 0.875rem;\n}\n\n/* Toggle Switch Styles */\n.toggle-container {\n  position: relative;\n  min-width: 60px;\n}\n\n.toggle-checkbox {\n  display: none;\n}\n\n.toggle-label {\n  display: block;\n  width: 60px;\n  height: 34px;\n  border-radius: 17px;\n  background: #cbd5e1;\n  cursor: pointer;\n  position: relative;\n  transition: background-color 0.3s ease;\n}\n\n.toggle-label:before {\n  content: '';\n  display: block;\n  width: 26px;\n  height: 26px;\n  border-radius: 13px;\n  background: white;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  transition: transform 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.toggle-checkbox:checked + .toggle-label {\n  background: #2196f3;\n}\n\n.toggle-checkbox:checked + .toggle-label:before {\n  transform: translateX(26px);\n}\n\n.toggle-checkbox:focus + .toggle-label {\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.2);\n}\n\n/* Schedules Section */\n.schedules-section {\n  padding: 20px;\n}\n\n.schedules-section .section-description {\n  color: #7f8c8d;\n  margin-bottom: 24px;\n}\n\n.schedules-overview {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 32px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n}\n\n.schedules-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.schedules-table th,\n.schedules-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.schedules-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.schedules-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.status-badge.enabled {\n  background-color: rgba(46, 204, 113, 0.15);\n  color: #27ae60;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.disabled {\n  background-color: rgba(149, 165, 166, 0.15);\n  color: #7f8c8d;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.completed {\n  background-color: rgba(46, 204, 113, 0.15);\n  color: #27ae60;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.running {\n  background-color: rgba(52, 152, 219, 0.15);\n  color: #2980b9;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.status-badge.failed {\n  background-color: rgba(231, 76, 60, 0.15);\n  color: #c0392b;\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.email-settings {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.email-badge {\n  padding: 2px 8px;\n  background-color: rgba(52, 152, 219, 0.15);\n  color: #2980b9;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.email-badge.disabled {\n  background-color: rgba(149, 165, 166, 0.15);\n  color: #7f8c8d;\n}\n\n.edit-schedule-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.edit-schedule-modal .modal-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.edit-schedule-modal .modal-content {\n  position: relative;\n  background: white;\n  border-radius: 12px;\n  padding: 32px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  z-index: 1001;\n}\n\n.edit-schedule-modal h3 {\n  margin-top: 0;\n  margin-bottom: 24px;\n  color: #2c3e50;\n}\n\n.edit-schedule-modal .form-group {\n  margin-bottom: 20px;\n}\n\n.edit-schedule-modal .form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.edit-schedule-modal .form-group select,\n.edit-schedule-modal .form-group .time-input,\n.edit-schedule-modal .form-group .email-input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.edit-schedule-modal .form-group .email-input {\n  font-family: monospace;\n}\n\n.edit-schedule-modal .form-group .form-help {\n  display: block;\n  margin-top: 6px;\n  font-size: 12px;\n  color: #7f8c8d;\n  font-style: italic;\n  line-height: 1.4;\n}\n\n.edit-schedule-modal .checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.edit-schedule-modal .checkbox-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: normal;\n  color: #7f8c8d;\n}\n\n.edit-schedule-modal .checkbox-group input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.edit-schedule-modal .form-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.edit-schedule-modal .save-btn {\n  flex: 1;\n  padding: 12px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.edit-schedule-modal .save-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n.edit-schedule-modal .cancel-btn {\n  flex: 1;\n  padding: 12px;\n  background: #f8f9fa;\n  color: #2c3e50;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.edit-schedule-modal .cancel-btn:hover {\n  background: #e0e0e0;\n}\n\n/* Staff Exclusion List Styles */\n.staff-exclusion-list {\n  max-height: 300px;\n  overflow-y: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  padding: 12px;\n  background: #f8f9fa;\n}\n\n.staff-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n  margin-bottom: 8px;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s;\n  font-weight: normal !important;\n  color: #2c3e50 !important;\n}\n\n.staff-checkbox:hover {\n  background: #f0f2f5;\n  transform: translateX(4px);\n}\n\n.staff-checkbox input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.staff-checkbox span {\n  flex-grow: 1;\n  font-size: 14px;\n}\n\n.loading-staff,\n.no-staff {\n  padding: 20px;\n  text-align: center;\n  color: #7f8c8d;\n  font-style: italic;\n  background: #f8f9fa;\n  border-radius: 6px;\n  border: 1px solid #e0e0e0;\n}\n\n.schedule-runs-section {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n  margin-top: 24px;\n}\n\n.schedule-runs-section h3 {\n  margin-top: 0;\n  margin-bottom: 20px;\n  color: #2c3e50;\n}\n\n.runs-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.runs-table th,\n.runs-table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.runs-table th {\n  background-color: #f8f9fa;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.runs-table tbody tr:hover {\n  background-color: #f8f9fa;\n}\n\n.changes-badge {\n  padding: 4px 8px;\n  background-color: rgba(241, 196, 15, 0.15);\n  color: #f39c12;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.no-changes {\n  color: #7f8c8d;\n  font-size: 12px;\n}\n\n.email-sent {\n  color: #27ae60;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.email-not-sent {\n  color: #e74c3c;\n  font-size: 16px;\n  font-weight: bold;\n}\n\n/* Enhanced Run Display */\n.error-summary {\n  margin-top: 4px;\n  font-size: 11px;\n  color: #e74c3c;\n  font-style: italic;\n}\n\n.progress-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.progress-text {\n  font-weight: 600;\n}\n\n.failed-count {\n  font-size: 11px;\n  color: #e74c3c;\n}\n\n.credits-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.credits-detail {\n  font-size: 11px;\n  color: #7f8c8d;\n}\n\n.view-logs-btn {\n  padding: 6px 12px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.view-logs-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n}\n\n/* Logs Modal */\n.logs-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.logs-modal-content {\n  max-width: 1200px !important;\n  width: 95% !important;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.logs-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-bottom: 20px;\n  border-bottom: 2px solid #e0e0e0;\n  margin-bottom: 20px;\n}\n\n.logs-modal .modal-header h3 {\n  margin: 0;\n  color: #2c3e50;\n}\n\n.logs-modal .close-btn {\n  background: none;\n  border: none;\n  font-size: 32px;\n  color: #7f8c8d;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s;\n}\n\n.logs-modal .close-btn:hover {\n  color: #e74c3c;\n  transform: rotate(90deg);\n}\n\n.loading-logs {\n  text-align: center;\n  padding: 40px;\n  color: #7f8c8d;\n  font-size: 18px;\n}\n\n/* Run Summary */\n.run-summary {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 24px;\n}\n\n.summary-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.summary-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.summary-item label {\n  font-size: 12px;\n  color: #7f8c8d;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.summary-item span {\n  font-size: 16px;\n  color: #2c3e50;\n  font-weight: 600;\n}\n\n.summary-item .success-count {\n  color: #27ae60;\n}\n\n.summary-item .failed-count {\n  color: #e74c3c;\n}\n\n.summary-item .changes-count {\n  color: #f39c12;\n}\n\n.error-banner {\n  background: rgba(231, 76, 60, 0.1);\n  border-left: 4px solid #e74c3c;\n  padding: 12px 16px;\n  border-radius: 4px;\n  color: #e74c3c;\n  font-size: 14px;\n}\n\n/* Staff Logs Section */\n.staff-logs-section {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.staff-logs-section h4 {\n  margin: 0 0 16px 0;\n  color: #2c3e50;\n  font-size: 18px;\n}\n\n.logs-list {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding-right: 8px;\n}\n\n/* Log Entry */\n.log-entry {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 16px;\n  transition: all 0.2s;\n}\n\n.log-entry:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.log-status-success {\n  border-left: 4px solid #27ae60;\n}\n\n.log-status-failed {\n  border-left: 4px solid #e74c3c;\n}\n\n.log-status-processing {\n  border-left: 4px solid #3498db;\n}\n\n.log-status-pending {\n  border-left: 4px solid #95a5a6;\n}\n\n.log-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.log-index {\n  background: #667eea;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  min-width: 40px;\n  text-align: center;\n}\n\n.log-staff-name {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.log-staff-name strong {\n  color: #2c3e50;\n  font-size: 14px;\n}\n\n.log-license {\n  font-size: 12px;\n  color: #7f8c8d;\n  font-family: monospace;\n}\n\n.log-status-badge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.log-status-badge.success {\n  background: rgba(46, 204, 113, 0.15);\n  color: #27ae60;\n}\n\n.log-status-badge.failed {\n  background: rgba(231, 76, 60, 0.15);\n  color: #e74c3c;\n}\n\n.log-status-badge.processing {\n  background: rgba(52, 152, 219, 0.15);\n  color: #3498db;\n}\n\n.log-status-badge.pending {\n  background: rgba(149, 165, 166, 0.15);\n  color: #7f8c8d;\n}\n\n/* Log Error */\n.log-error {\n  background: rgba(231, 76, 60, 0.1);\n  border-radius: 6px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.error-code {\n  background: #e74c3c;\n  color: white;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  align-self: flex-start;\n  font-family: monospace;\n}\n\n.error-message {\n  color: #c0392b;\n  font-size: 13px;\n}\n\n/* Log Success */\n.log-success {\n  background: rgba(46, 204, 113, 0.1);\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 8px;\n}\n\n.changes-indicator {\n  color: #f39c12;\n  font-weight: 600;\n  font-size: 13px;\n}\n\n.no-changes-indicator {\n  color: #7f8c8d;\n  font-size: 13px;\n}\n\n.change-details {\n  margin-top: 8px;\n  padding-top: 8px;\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.change-details ul {\n  margin: 0;\n  padding-left: 20px;\n}\n\n.change-details li {\n  color: #2c3e50;\n  font-size: 12px;\n  margin-bottom: 4px;\n}\n\n/* Log Footer */\n.log-footer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  font-size: 11px;\n  color: #7f8c8d;\n  padding-top: 8px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.log-duration,\n.log-credits,\n.log-timestamp {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.no-logs {\n  text-align: center;\n  padding: 40px;\n  color: #7f8c8d;\n  font-style: italic;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n/* Modal Footer */\n.modal-footer {\n  padding-top: 20px;\n  border-top: 2px solid #e0e0e0;\n  margin-top: 20px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.close-footer-btn {\n  padding: 12px 24px;\n  background: #f8f9fa;\n  color: #2c3e50;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.close-footer-btn:hover {\n  background: #e0e0e0;\n}\n\n/* Active Runs Section with Live Progress */\n.active-runs-section {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 32px;\n  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);\n  animation: slideDown 0.3s ease-out;\n  scroll-margin-top: 20px;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Initializing Run Card */\n.initializing-run-card {\n  background: white;\n  border-radius: 8px;\n  padding: 30px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  margin-bottom: 16px;\n  animation: fadeIn 0.4s ease-out;\n  border-left: 4px solid #667eea;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.98);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.initializing-content {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #e0e0e0;\n  border-top: 4px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.initializing-text {\n  flex: 1;\n}\n\n.initializing-text strong {\n  font-size: 18px;\n  color: #2c3e50;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.initializing-text p {\n  font-size: 14px;\n  color: #7f8c8d;\n  margin: 0;\n}\n\n.active-runs-section h3 {\n  color: white;\n  margin: 0 0 20px 0;\n  font-size: 24px;\n  font-weight: 700;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.active-runs-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.active-run-card {\n  background: white;\n  border-radius: 8px;\n  padding: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  animation: fadeIn 0.4s ease-out;\n  border-left: 4px solid #667eea;\n}\n\n.active-run-card.completed {\n  background: linear-gradient(to right, #f0f9ff 0%, #ffffff 100%);\n  border-left-color: #10b981;\n  opacity: 0.95;\n}\n\n.active-run-card.completed .active-run-header {\n  opacity: 0.9;\n}\n\n.active-run-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 2px solid #f0f0f0;\n}\n\n.active-run-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.active-run-title strong {\n  font-size: 18px;\n  color: #2c3e50;\n}\n\n.active-run-time {\n  color: #7f8c8d;\n  font-size: 13px;\n}\n\n/* Progress Bar Container */\n.progress-bar-container {\n  margin-bottom: 20px;\n}\n\n.progress-bar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.progress-label {\n  font-weight: 600;\n  color: #2c3e50;\n  font-size: 15px;\n}\n\n.progress-percent {\n  font-weight: 700;\n  color: #667eea;\n  font-size: 16px;\n}\n\n.progress-bar-wrapper {\n  width: 100%;\n  height: 24px;\n  background: #e0e0e0;\n  border-radius: 12px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n  border-radius: 12px;\n  position: relative;\n  transition: width 0.5s ease;\n  overflow: hidden;\n}\n\n.progress-bar-shimmer {\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.3),\n    transparent\n  );\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    left: -100%;\n  }\n  100% {\n    left: 100%;\n  }\n}\n\n/* Active Run Stats */\n.active-run-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px;\n  background: #f8f9fa;\n  border-radius: 6px;\n}\n\n.stat-label {\n  font-size: 12px;\n  color: #7f8c8d;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.stat-value {\n  font-size: 20px;\n  font-weight: 700;\n  color: #2c3e50;\n}\n\n.success-stat .stat-value {\n  color: #27ae60;\n}\n\n.failed-stat .stat-value {\n  color: #e74c3c;\n}\n\n/* Recent Logs in Active Run */\n.active-run-recent-logs {\n  background: #f8f9fa;\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 12px;\n}\n\n.recent-logs-label {\n  font-size: 12px;\n  color: #7f8c8d;\n  font-weight: 600;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n}\n\n.recent-log-entry {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0;\n  font-size: 13px;\n}\n\n.log-staff {\n  color: #2c3e50;\n  font-weight: 500;\n}\n\n.log-status {\n  font-size: 16px;\n}\n\n.active-run-error {\n  background: rgba(231, 76, 60, 0.1);\n  border-left: 4px solid #e74c3c;\n  padding: 12px;\n  border-radius: 6px;\n  color: #e74c3c;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n/* Live Progress in Table */\n.running-row {\n  background: rgba(102, 126, 234, 0.05) !important;\n  animation: pulse-row 2s ease-in-out infinite;\n}\n\n@keyframes pulse-row {\n  0%, 100% {\n    background: rgba(102, 126, 234, 0.05);\n  }\n  50% {\n    background: rgba(102, 126, 234, 0.1);\n  }\n}\n\n.status-badge.pulsing {\n  animation: pulse-badge 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse-badge {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.05);\n  }\n}\n\n.status-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.live-progress-container {\n  width: 100%;\n}\n\n.progress-bar-header-small {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #2c3e50;\n}\n\n.progress-percent-small {\n  color: #667eea;\n  font-weight: 700;\n}\n\n.progress-bar-wrapper-small {\n  width: 100%;\n  height: 16px;\n  background: #e0e0e0;\n  border-radius: 8px;\n  overflow: hidden;\n  position: relative;\n}\n\n.progress-bar-fill-small {\n  height: 100%;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n  border-radius: 8px;\n  position: relative;\n  transition: width 0.5s ease;\n  overflow: hidden;\n}\n\n.progress-bar-fill-small .progress-bar-shimmer {\n  animation: shimmer 1.5s infinite;\n}\n\n/* Email Status Badges */\n.email-status-cell {\n  display: flex;\n  align-items: center;\n}\n\n.email-sent-badge {\n  padding: 6px 12px;\n  background: rgba(46, 204, 113, 0.15);\n  color: #27ae60;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.email-not-sent-badge {\n  padding: 6px 12px;\n  background: rgba(231, 76, 60, 0.15);\n  color: #e74c3c;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.email-pending-badge {\n  padding: 6px 12px;\n  background: rgba(52, 152, 219, 0.15);\n  color: #3498db;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  animation: pulse-badge 2s ease-in-out infinite;\n}\n\n.recipient-emails {\n  font-size: 12px;\n}\n\n.recipient-emails .email-list {\n  padding: 4px 8px;\n  background-color: rgba(52, 152, 219, 0.15);\n  color: #2980b9;\n  border-radius: 4px;\n  font-weight: 600;\n  cursor: help;\n}\n\n.recipient-emails .default-email {\n  color: #7f8c8d;\n  font-style: italic;\n  cursor: help;\n}\n\n.action-buttons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.run-now-btn {\n  padding: 6px 12px;\n  background: linear-gradient(135deg, #2ecc71 0%, #27ae60 100%);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.run-now-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(46, 204, 113, 0.3);\n}\n\n.run-now-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.run-now-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.run-now-btn.loading {\n  background: linear-gradient(135deg, #3498db 0%, #2980b9 100%);\n  animation: pulse-button 1.5s ease-in-out infinite;\n}\n\n@keyframes pulse-button {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.8;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
